// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorMoqRules = (client) => ({
    /**
     * `POST /vendor/moq-rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/moq-rules/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/moq-rules", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/moq-rules/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/moq-rules/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/moq-rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListMoqRules
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/moq-rules/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/moq-rules", { method: "GET", query, headers }),
    /**
     * `GET /vendor/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/moq-rules/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/moq-rules/:id", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /vendor/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/moq-rules/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/moq-rules/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=moq-rules.js.map